import React from 'react';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';

import {
    ALO_ACCOUNT_ACTIVE_STATE,
    ALO_ACCOUNT_ERROR_STATE,
    ALO_ACCOUNT_SUSPENDED_STATE
} from '../../../../constants/alo';
import {
    MODAL_TYPE_ALO_DELETE_ACCOUNT,
    MODAL_TYPE_ALO_REACTIVATE_ACCOUNT
} from '../../../../services/modal/constants';
import { STATIC_ROOT } from '../../../../constants';

import { showModal } from '../../../../services/modal/actions';
import { fetchAccountConnectionsIfNeeded } from '../../../../services/account/alo/actions';

import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';

import SvgComponent from '../../../SvgComponent';
import ButtonComponent from '../../../button/ButtonComponent';
import { LoadingComponent } from '../../../loading/LoadingComponent';

import './AloComponent.scss';
import { medium } from '../../../../scss/_variables.scss';

export class AloComponent extends React.Component {
    componentDidMount() {
        this.props.fetchAccountConnectionsIfNeeded();
    }

    showDeleteAccountModal = props =>
        this.props.showModal(MODAL_TYPE_ALO_DELETE_ACCOUNT, { ...props });
    showReactivateAccountModal = props =>
        this.props.showModal(MODAL_TYPE_ALO_REACTIVATE_ACCOUNT, { ...props });

    getAccountCssClass = status => {
        if (ALO_ACCOUNT_SUSPENDED_STATE.includes(status)) {
            return 'suspended';
        } else if (ALO_ACCOUNT_ERROR_STATE.includes(status)) {
            return 'desactivated';
        } else {
            return '';
        }
    };

    getAccountStatus = status => {
        const { i18n } = this.props;

        if (ALO_ACCOUNT_ACTIVE_STATE.includes(status)) {
            return i18n.STATE.ASSOCIATED;
        } else if (ALO_ACCOUNT_SUSPENDED_STATE.includes(status)) {
            return i18n.STATE.SUSPENDED;
        } else {
            return i18n.STATE.CLOSED;
        }
    };

    renderStatus = account => {
        return (
            <div>
                <div
                    className={`checkmark-wrapper ${this.getAccountCssClass(account.status)}`}
                    onClick={() =>
                        this.showDeleteAccountModal({
                            account: account
                        })
                    }>
                    <span />
                </div>
                <div className={`status ${this.getAccountCssClass(account.status)}`}>
                    {this.getAccountStatus(account.status)}
                </div>
            </div>
        );
    };

    renderReactiveButton = account => {
        const { i18n } = this.props;

        if (ALO_ACCOUNT_SUSPENDED_STATE.includes(account.status)) {
            return (
                <MediaQuery query={`(min-width: ${medium})`}>
                    {matches =>
                        matches ? (
                            <ButtonComponent
                                text={i18n.TABLE.REACTIVATE_ACCOUNT}
                                color="seventh"
                                onClick={() =>
                                    this.showReactivateAccountModal({
                                        accountId: account.id
                                    })
                                }
                            />
                        ) : (
                            <React.Fragment>
                                <span
                                    className="reactivate-link"
                                    onClick={() =>
                                        this.showReactivateAccountModal({
                                            accountId: account.id
                                        })
                                    }>
                                    {i18n.TABLE.REACTIVATE_ACCOUNT_MOBILE}
                                </span>
                                <SvgComponent
                                    src={`${STATIC_ROOT}/chevron.svg`}
                                    width="5"
                                    height="10"
                                />
                            </React.Fragment>
                        )
                    }
                </MediaQuery>
            );
        }
    };

    render() {
        const { i18n, connections, connectionsFetching } = this.props;

        return (
            <div id="alo-table">
                <table className="table">
                    <thead>
                        <tr>
                            <th>{i18n.TABLE.TH_BANK}</th>
                            <th>{i18n.TABLE.TH_STATE}</th>
                            <th>{i18n.TABLE.TH_DELETE}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {!connectionsFetching &&
                            connections.length > 0 &&
                            connections.map(holder => (
                                <React.Fragment key={holder.connection.id}>
                                    <tr className="connection">
                                        <td className="bank" colSpan="2">
                                            {holder.connection.name}
                                            {convertHtmlToReactDomWithParams(
                                                i18n.TABLE.ACCOUNT_NUMBER,
                                                holder.accounts.length,
                                                holder.accounts.length > 1 ? 's' : ''
                                            )}
                                        </td>
                                        <td className="delete">
                                            <div
                                                onClick={() =>
                                                    this.showDeleteAccountModal({
                                                        connection: holder.connection
                                                    })
                                                }>
                                                <SvgComponent
                                                    src={`${STATIC_ROOT}/trash.svg`}
                                                    width="10"
                                                    height="13"
                                                />
                                                {i18n.TABLE.DELETE_ALL}
                                            </div>
                                        </td>
                                    </tr>
                                    {holder.accounts.map((account, i) => (
                                        <tr key={account.id} className="account">
                                            <td className="bank">
                                                <div>
                                                    <p className="detail">
                                                        {i === 0 && i18n.TABLE.DETAIL}
                                                    </p>
                                                    <p>{account.name}</p>
                                                </div>
                                            </td>
                                            <td className="status">{this.renderStatus(account)}</td>
                                            <td className="button">
                                                <div>{this.renderReactiveButton(account)}</div>
                                            </td>
                                        </tr>
                                    ))}
                                </React.Fragment>
                            ))}
                        {connections && connections.length === 0 && (
                            <tr>
                                <td className="empty" colSpan="3">
                                    {connectionsFetching ? <LoadingComponent /> : i18n.NO_ACCOUNT}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <div className="legend">
                    <p>{convertHtmlToReactDomWithParams(i18n.LEGEND.ASSOCIATED)}</p>
                    <p>{convertHtmlToReactDomWithParams(i18n.LEGEND.SUSPENDED)}</p>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.ACCOUNT.ALO,
        connectionsFetching: state.account.accountLinkedOffer.fetching,
        connections: state.account.accountLinkedOffer.connections
    };
};

const mapDispatchtoProps = {
    fetchAccountConnectionsIfNeeded,
    showModal
};

export default connect(mapStateToProps, mapDispatchtoProps)(AloComponent);



// WEBPACK FOOTER //
// ./src/components/pages/account/alo/AloComponent.js